import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

export default function LiveDot({ color = 'online', size = 'sm', animated = true, className = '' }) {
  const classes = [
    'live-dot',
    `live-dot--${color}`,
    `live-dot--${size}`,
    animated ? 'live-dot--animated' : '',
    className,
  ].filter(Boolean).join(' ');

  return <span className={classes} aria-hidden="true" />;
}

LiveDot.propTypes = {
  color: PropTypes.oneOf(['online', 'accent']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  animated: PropTypes.bool,
  className: PropTypes.string,
};
